
import { Component, Prop, Vue } from 'vue-property-decorator'
import ImageBase from '@/components/atoms/ImageBase.vue'
import ButtonOptional from '@/components/molecules/ButtonOptional.vue'
import GradeTip from '@/components/organisms/GradeTip.vue'
import OverflowTextTooltip from '@/components/molecules/OverflowTextTooltip.vue'
import { AvatarCode } from '@/const/AvatarCode'
import { StudentProgress } from '@/models/manage/StudentProgress'

/**
 * 生徒進捗確認テーブル
 */
@Component({
  components: {
    ImageBase,
    ButtonOptional,
    GradeTip,
    OverflowTextTooltip,
  },
})
export default class StudentProgressTable extends Vue {
  /** 生徒一覧 */
  @Prop()
  private studentList!: StudentProgress[]

  /** 詳細ボタン押下時のイベント */
  @Prop()
  private eventClickDetailButton!: (userId: number) => Promise<void>

  /**
   * 「教室」カラムの有無
   *
   * @returns 「教室」カラムがあればtrue
   */
  private get hasColumnBranch(): boolean {
    return !!this.$scopedSlots.headerBranch
  }

  /**
   * アイコンコードからアイコン画像のパスを引き当てる
   *
   * @param code アイコンコード
   * @returns アイコン画像のパス
   */
  private iconUrl(code: string | null): string {
    const avatar = AvatarCode.findByCode(code)
    return avatar.path
  }
}
